import React, { Fragment } from 'react';
import { Col, Row, Container } from 'reactstrap';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaLink } from '../Fields/ArcaLink';

export class FirstItemOnPage extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    tidyup(str) {
        str = str.toLowerCase().replace(' ', '-');
        return str;
    }

    render() {
        let { details } = this.props

        let title = <Fragment>
            {details.Title && details.Photo
                ? <h1 id={'#' + this.tidyup(details.Title)}>{details.Title}</h1>
                : null}
        </Fragment>

        let text = <Fragment>
            {details.Preamble
                ? <strong>{details.Preamble}</strong>
                : null}
            {details.Description?.split('/n').map((d, k) => <p key={k}>{d}</p>)}
        </Fragment>

        let image =
            details.Photo
                ? <img src={ArcaHttpSystem.PhotoFolder + 'Photos/' + details.Photo + `.jpg`} width='100%' />
                : <h1 id={'#' + this.tidyup(details.Title)}>{details.Title}</h1>

        return (
            <Fragment>

                    {ArcaHttpSystem.IsSmartphone
                        ? <Container className='topAndBottomPanels'>
                            <Row>
                                <Col>
                                    {image}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {title}
                                    {text}
                                    <a href='#contactUs'>
                                        <ArcaLink
                                            onClick={() => { }}
                                            text='Contact us'
                                            width='100%' />
                                    </a>
                                </Col>
                            </Row>
                        </Container>

                        : <Container className='topAndBottomPanels'>
                            <Row>
                                <Col>
                                    {image}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs='5'>
                                    {title}
                                </Col>
                                <Col xs='7'>
                                    {text}
                                    <a href='#contactUs'>
                                        <ArcaLink
                                            onClick={() => { }}
                                            text='Contact us'
                                            width='160px' />
                                    </a>
                                </Col>
                            </Row>
                        </Container>
                    }
            </Fragment >
        );
    }
}